import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

export const firebaseConfig = {
  apiKey: "AIzaSyAf-Rzz_f6IqvP3KKkRHvmBAps59yKMg80",
  authDomain: "four-play-1d641.firebaseapp.com",
  projectId: "four-play-1d641",
  storageBucket: "four-play-1d641.firebasestorage.app",
  messagingSenderId: "221853285822",
  appId: "1:221853285822:web:508f6eb01538da15138def",
  measurementId: "G-X214YPJHKD"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();